import { render, staticRenderFns } from "./UserCheckCore.vue?vue&type=template&id=33b6988a&"
import script from "./UserCheckCore.vue?vue&type=script&lang=js&"
export * from "./UserCheckCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports